import { Component, OnInit } from '@angular/core';
import {LoadingController, NavController} from '@ionic/angular';
import {ApiService} from '../../../services/api.service';
import {ToastService} from '../../../services/toast.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-answer',
  templateUrl: './answer.page.html',
  styleUrls: ['./answer.page.scss'],
})
export class AnswerPage implements OnInit {
  token: any;
  qrcode: any;

  constructor(private navController: NavController,
              private route: ActivatedRoute,
              private apiService: ApiService,
              private loadingController: LoadingController,
              private toastService: ToastService) {
  }

  ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('token');
    this.getQrcode();
  }

  async getQrcode(){
    const loading = await this.loadingController.create({
      spinner: 'circular'
    });

    loading.present();
    // Call API pour récupérer le qrcode
    this.apiService.qrcodeApi.getWithToken(this.token).then((data) => {
      this.qrcode = data;
      loading.dismiss();
    }).catch((e) => {
      this.navController.navigateBack('/home');
      loading.dismiss();
    });
  }

  quit() {
    this.navController.navigateBack('/home');
  }

  goBack() {
    this.navController.navigateBack('/home');
  }

  async accept(){
    const loading = await this.loadingController.create({
      spinner: 'circular'
    });

    loading.present();

    const data = {
      accept: true,
      paravolName: this.qrcode?.name,
      token: this.token
    };

    this.apiService.qrcodeApi.setRenunciation(data).then((qr) => {
      this.qrcode = qr;
      loading.dismiss();

    }).catch((e) => {
      loading.dismiss();
    });
  }

  async deny(){
    const loading = await this.loadingController.create({
      spinner: 'circular'
    });

    const data = {
      accept: false,
      paravolName: this.qrcode?.name,
      token: this.token
    };

    loading.present();

    this.apiService.qrcodeApi.setRenunciation(data).then((qr) => {
      this.qrcode = qr;
      loading.dismiss();

    }).catch((e) => {
      loading.dismiss();
    });
  }
}
